module.exports = __webpack_public_path__ + "static/media/Scones.6c833834.jpeg";